<!--
 * @Author: Merlin
 * @Date: 2024-03-11 09:59:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-01 19:56:25
 * @Description: 用处说明：
    各个游戏界面都有【规则】按钮，点击后将弹出窗口，此窗口上方的页签此是此组件 
-->

<template>
    <div class="bg-[rgba(55,70,92,.3)] flex p-1 rounded-md">
        <Button @click="onInterEnableClick" class="flex-1 h-[36px]" :mode="modelValue ? '' : 'primary'">
            {{ disableText }}
        </Button>
        <Button @click="onInterEnableClick" class="flex-1 h-[36px]" :mode="modelValue ? 'primary' : ''">
            {{ enableText }}
        </Button>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
    disableText: {
        type: String,
        default: 'Disable'
    },
    enableText: {
        type: String,
        default: 'Enable'
    },
    onEnableClick: {
        type: Function,
        default: () => { }
    },
    onDisableClick: {
        type: Function,
        default: () => { }
    },
    modelValue: {
        type: Boolean,
        default: false
    },
});

const emit = defineEmits(['update:modelValue']);

const onInterEnableClick = () => {
    if (props.modelValue) {
        props.onEnableClick()
        emit('update:modelValue', false)
    } else {
        props.onDisableClick()
        emit('update:modelValue', true)
    }
}
</script>